
//table columns for lab test 
export const columns: TableColumn[] = [
    {
        Header: 'operatorManagement.tableColumns.slNo',
        accessor: 'slno',
      },
      {
        Header: 'scheduleOperator.tableColumns.production_schedule',
        accessor: 'production_schedule_name',
      },
      {
        Header: 'scheduleOperator.tableColumns.product_name',
        accessor: 'product_name',
      },
      {
        Header: 'tableCommon.batch_code',
        accessor: 'batch_number',
      },
      {
        Header: 'tableCommon.seriel_number',
        accessor: 'serial_number',
      },
      {
        Header: 'operatorManagement.tableColumns.labTestDoneOn',
        accessor: 'labTestDoneOn',
      },
      {
        Header: 'operatorManagement.tableColumns.colonyCount',
        accessor: 'colonyCount',
      },
      {
        Header: 'operatorManagement.tableColumns.testRemark',
        accessor: 'testRemarks',
      },
  ];
  

  export const PendingColumns: TableColumn[] = [
    {
        Header: 'operatorManagement.tableColumns.slNo',
        accessor: 'sl_no',
      },
      {
        Header: 'scheduleOperator.tableColumns.production_schedule',
        accessor: 'production_schedule',
      },
      {
        Header: 'scheduleOperator.tableColumns.product_name',
        accessor: 'product_name',
      },
      {
        Header: 'operatorManagement.tableColumns.serialNo',
        accessor: 'serial_number',
      },
      {
        Header: 'tableCommon.batch_code',
        accessor: 'batch_code',
      },
      {
        Header: 'operatorManagement.tableColumns.plateType',
        accessor: 'plate_type',
      },
      {
        Header: 'operatorManagement.tableColumns.labStatus',
        accessor: 'lab_status',
      },
  ];


  interface TableColumn {
    Header: string;
    accessor: string;
  }
  